import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { smoothScrollToTop } from "./CommonUtils";


export const RouteChangeTracker = (): null => {
  const pathname = useLocation().pathname;

  useEffect(() => {
    smoothScrollToTop();
  }, [pathname]);

  return null;
}